import $ from 'jquery';

const setSideList = () => {
  const $list = $('.side-list');
  if ($list.length < 1) { return; }

  $list.each(function(){
    const $this     = $(this),
          $item     = $this.find('li'),
          selectSrc = '<select name="archive-dropdown" onChange="document.location.href=this.options[this.selectedIndex].value;"></select>',
          optionTxt = $this.attr('data-option'),
          optionSrc = '<option value="">' + optionTxt + '</option>';

    $this.after(selectSrc);

    const $select = $this.next();
    $select.append(optionSrc);
    $item.clone().appendTo($select);
    $select.find('li').replaceWith(function(){
      const $this = $(this),
            url   = $this.find('a').attr('href'),
            text  = $this.text();
      return '<option value="' + url + '">' + text + '</option>';
    });
    $select.wrap('<div class="select" />');

  });
};

const switchSideList = (MYAPP) => {
  const $select = $('.select');
  if ($select.length < 1) { return; }

  if (MYAPP.isMobile) {
    $select.show().prev().hide();
  } else {
    $select.hide().prev().show();
  }
};

module.exports = {
  setSideList : setSideList,
  switchSideList : switchSideList
};



// WEBPACK FOOTER //
// ./src/js/modules/blog.js